import { createFileRoute, Link } from "@tanstack/react-router";
import { SiteShell } from "@/components/layout/SiteShell";
import { ALL_WESTERN_ZODIACS, zodiacSlug } from "@/lib/calendar/zodiac";
import { withSlash } from "@/lib/url";

export const Route = createFileRoute("/zodiak/")({
  head: () => {
    const title = "Zodiak Barat - 12 Bintang & Tanggal Lahirnya";
    const desc = "Daftar lengkap 12 zodiak barat: Aries, Taurus, Gemini, Cancer, Leo, Virgo, Libra, Scorpio, Sagitarius, Kaprikornus, Akuarius, Pisces. Cek tanggal lahir, sifat, dan elemen.";
    const canonical = "https://hari.co.id/zodiak/";
    const ld = {
      "@context": "https://schema.org",
      "@type": "ItemList",
      itemListElement: ALL_WESTERN_ZODIACS.map((z, i) => ({
        "@type": "ListItem",
        position: i + 1,
        url: `https://hari.co.id/zodiak/${zodiacSlug(z)}/`,
        name: z.nameId,
      })),
    };
    return {
      meta: [
        { title },
        { name: "description", content: desc },
        { property: "og:title", content: title },
        { property: "og:description", content: desc },
        { property: "og:url", content: canonical },
      ],
      links: [{ rel: "canonical", href: canonical }],
      scripts: [{ type: "application/ld+json", children: JSON.stringify(ld) }],
    };
  },
  component: ZodiakIndex,
});

function ZodiakIndex() {
  return (
    <SiteShell>
      <div className="mx-auto max-w-4xl py-10">
        <nav className="mb-4 text-sm text-muted-foreground">
          <Link to="/" className="hover:text-primary">Beranda</Link> / Zodiak
        </nav>
        <h1 className="font-display text-4xl tracking-tight md:text-5xl">
          Zodiak Barat: 12 Bintang & Tanggal Lahir
        </h1>
        <p className="mt-3 text-muted-foreground max-w-2xl">
          Pilih zodiakmu untuk membaca sifat, elemen, planet penguasa,
          angka keberuntungan, dan zodiak yang cocok. Atau cek tanggal lahir
          tertentu untuk tahu zodiaknya.
        </p>
        <div className="mt-8 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {ALL_WESTERN_ZODIACS.map((z) => (
            <Link
              key={z.id}
              to={withSlash(`/zodiak/${zodiacSlug(z)}`) as never}
              className="rounded-lg border border-border bg-card p-4 hover:border-primary"
            >
              <div className="flex items-center gap-3">
                <span className="text-3xl">{z.symbol}</span>
                <div>
                  <div className="font-semibold">{z.nameId}</div>
                  <div className="text-xs text-muted-foreground">{z.rangeId} · {z.elementId}</div>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 rounded-lg border border-border bg-gradient-to-r from-primary/5 to-primary/10 p-5">
          <h2 className="font-display text-xl">Kalkulator Kecocokan Zodiak</h2>
          <p className="mt-1 text-sm text-muted-foreground">
            Cek skor kecocokan antar zodiak untuk cinta, persahabatan, dan kerja — 78 pasangan unik tersedia.
          </p>
          <Link
            to={withSlash("/zodiak/cocok") as never}
            className="mt-3 inline-block rounded-md bg-primary px-4 py-2 text-sm font-semibold text-primary-foreground hover:bg-primary/90"
          >
            Buka Kalkulator Kecocokan →
          </Link>
        </div>
      </div>
    </SiteShell>
  );
}